import { isClientOriginOrPathZillow } from '../validators/isClientOriginOrPathZillow';
import { getZHLPath } from './getZHLPath';
import { getZillowPath } from './getZillowPath';

/**
 * Resolves the path for an experience, handling the differing path prefixes between domains.
 *
 * Example: Dashboard is on `/dashboard`, with the ZHL prefix being `/mortgage/dashboard`, and the Zillow
 * prefix being `/homeloans/mortgage`, so if passed localPath `/dashboard`, this will resolve either
 * `/homeloans/mortgage/dashboard` or `/mortgage/dashboard` based on the domain it is run on.
 *
 * @param localPath a prefix-agnostic path to an experience.
 */
const getResolvedPath = (localPath: string): string => {
    if (!localPath.startsWith('/')) {
        throw new Error('Local path must start with a /');
    }
    if (isClientOriginOrPathZillow()) {
        return getZillowPath(localPath);
    }

    return getZHLPath(localPath);
};

export { getResolvedPath };
